export default {
  addOns: 'Ek Hizmetler',
  availability: 'Uygunluk',
  availabilityDaySelector: 'Uygunluk tarih se\u00e7ici',
  unavailable: 'Uygun de\u011fil',
  person: 'ki\u015fi',
  people: 'ki\u015fi',
  reserveNow: '\u015eimdi rezerve et',
  selectTime: 'Saat se\u00e7in',
  select: 'Se\u00e7',
  reserve: 'Rezerve Et',
  time: 'Saat',
  tier: 'Kademe',
  questions: 'Sorular',
  addToCart: 'Sepete ekle',
  checkout: '\u00d6deme',
  total: 'Toplam',
  whatsIncluded: 'Neler dahil',
  showMore: 'Daha fazla g\u00f6ster',
  showLess: 'Daha az g\u00f6ster',
  session: 'Seans',
  viewDetails: 'Ayr\u0131nt\u0131lar\u0131 g\u00f6r\u00fcnt\u00fcle',
  findAvailability: 'Uygunluk Bul',
  loading: 'Y\u00fckleniyor',
  capacity: 'Kapasite',
  noAvailableSessionsOnThisDate: 'Bu tarihte uygun seans yok',
  noGroupAvailableOnThisDateAndTime:
    'Bu tarih ve saatte uygun {{groupTitle}} yok',
  noCollectionFound: 'Koleksiyon bulunamad\u0131!',
  noResourceGroupFound: 'Kaynak grubu bulunamad\u0131!',
  noData: 'Veri yok!',
  continue: 'Devam',
  night: 'gece',
  nights: 'gece',
  noAvailableSessionsForSelectedDates:
    'Se\u00e7iminizde baz\u0131 tarihlerde uygun seans yok. L\u00fctfen farkl\u0131 tarihler se\u00e7in.',
  from: 'ba\u015flang\u0131\u00e7',
  dateRangeSelector: 'Tarih aral\u0131\u011f\u0131 se\u00e7ici',
  priceTierRadioGroup: 'Fiyat kademesi se\u00e7ici',
  startTime: 'Başlangıç saati',
  duration: 'Süre',
  lengthOfStay: 'Konaklama süresi',
  startDate: 'Başlangıç tarihi',
  endDate: 'Bitiş tarihi',
  selectDates: 'Tarih seçin',
  more: 'Daha fazla',
  selectStartTime: 'Bir başlangıç saati seçin',
  endTime: 'Bitiş saati',
  selectEndTime: 'Bir bitiş saati seçin',
  morning: 'Sabah',
  afternoon: 'Öğleden sonra',
  save: 'Kaydet',
  selectDuration: 'Bir süre seçin',
  forLength: '{{length}} için',
  moreDates: '{{count}} daha',
  addDate: 'Tarih ekle',
  start: 'Başlangıç',
  end: 'Bitiş',
  pickupFrom: 'Teslim alma saati',
  returnBy: 'İade saati',
  day: 'gün',
  days: 'gün',
  hour: 'saat',
  hours: 'saat',
};
